const BASE_URL = 'https://api.app.pixventa.com';

export async function getProductos() {
  const res = await fetch(`${BASE_URL}/productos`);
  return res.json();
}

export async function crearProducto(data) {
  const res = await fetch(`${BASE_URL}/productos`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return res.json();
}

export async function eliminarProducto(id) {
  const res = await fetch(`${BASE_URL}/productos/${id}`, {
    method: 'DELETE',
  });
  return res.json();
}

export async function actualizarStock(varianteId, stock) {
  const res = await fetch(`${BASE_URL}/variantes/${varianteId}/stock`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ stock }),
  });
  return res.json();
}